module.exports = __webpack_public_path__ + "img/ancrown1.f4e6eb30.png";